export type RiskScaleKey = "nri" | "eventDensity" | "wildfire" | "flood";

export type RiskSegment = {
  color: string;
  background: string;
  text: string;
};

export const RISK_SEGMENTS = {
  BLUE: { color: "#5AA9F0", background: "#E3F3FF", text: "#0071A9" },
  GREEN: { color: "#5BCB6B", background: "#D6FCDC", text: "#027D37" },
  YELLOW: { color: "#F7DC46", background: "#FFF6CC", text: "#806E06" },
  ORANGE: { color: "#EE7A33", background: "#FEECE4", text: "#B34A04" },
  RED: { color: "#C8283C", background: "#FFEBEA", text: "#D6033B" },
} satisfies Record<string, RiskSegment>;

const FIVE_SEGMENTS = [
  RISK_SEGMENTS.BLUE,
  RISK_SEGMENTS.GREEN,
  RISK_SEGMENTS.YELLOW,
  RISK_SEGMENTS.ORANGE,
  RISK_SEGMENTS.RED,
];

const FOUR_SEGMENTS = [RISK_SEGMENTS.GREEN, RISK_SEGMENTS.YELLOW, RISK_SEGMENTS.ORANGE, RISK_SEGMENTS.RED];

const RISK_SCALES: Record<RiskScaleKey, { segments: RiskSegment[]; levels: Record<string, number> }> = {
  nri: {
    segments: FIVE_SEGMENTS,
    levels: {
      "no exposure": 0,
      negligible: 0,
      low: 1,
      moderate: 2,
      elevated: 3,
      high: 3,
      "very high": 4,
      maximum: 4,
    },
  },
  eventDensity: {
    segments: FIVE_SEGMENTS,
    levels: { negligible: 0, low: 1, moderate: 2, high: 3, extreme: 4 },
  },
  wildfire: {
    segments: FOUR_SEGMENTS,
    levels: { low: 0, medium: 1, high: 2, "very high": 3 },
  },
  flood: {
    segments: FIVE_SEGMENTS,
    levels: { none: 0, low: 1, moderate: 2, sfha: 4, "coastal high risk": 4 },
  },
};

export const getRiskScalePosition = (
  scale: RiskScaleKey | undefined,
  label: unknown,
): { segments: RiskSegment[]; activeIndex: number | null } | null => {
  if (!scale) return null;
  const { segments, levels } = RISK_SCALES[scale];
  const normalized = typeof label === "string" ? label.trim().toLowerCase() : "";
  const activeIndex = levels[normalized];
  return { segments, activeIndex: activeIndex ?? null };
};
